import React from 'react';
import './HomePageCharts.scss';
import chartSvg from '../../assets/icons/pie-chart.svg';
const HomePageCharts = () => (
	<React.Fragment>
		<div className='chart-container'>
			<div className='row chart-row'>
				<div className='col-sm-12 col-md-4 chart-col'>
					<h4>
						£<span className='pink'>77</span>bn
					</h4>
					<p>is the cost of lost productivity by British firms through sick employees in 2018</p>
					<p>
						Source:{' '}
						<a href='https://www.uk.mercer.com/newsroom/Unhealthy-employees-now-cost-British-firms-six-working-weeks-a-year-in-lost-productivity.html'>
							Mercer
						</a>
					</p>
				</div>
				<div className='col-sm-12 col-md-4 chart-col'>
					<div className='chart-icon' style={{ backgroundImage: `url(${chartSvg})` }}></div>
					<p>of employers reported in 2018 that their employees come to work when they are sick</p>
					<p>
						Source:{' '}
						<a href='https://www.cipd.co.uk/about/media/press/020518-health-wellbeing-survey'>
							CIPD
						</a>
					</p>
				</div>
				<div className='col-sm-12 col-md-4 chart-col'>
					<h4>
						2 <span className='pink'>weeks</span>
					</h4>
					<p>is the amount of time one in five patients waited for a GP appointment in Oct 2018</p>
					<p>
						Source: <a href='https://www.bmj.com/content/363/bmj.k5221'>BMJ</a>
					</p>
				</div>
			</div>
		</div>
	</React.Fragment>
);

export default HomePageCharts;
